import { ApplicationStatus } from '@/@types/generated'
import { buildPath, Params } from '@/routes'
import { type PropsWithChildren } from 'react'
import { Navigate, Outlet, useLocation, useParams } from 'react-router'
import { useCertificateApplication } from '../hooks/application-provider'

// Guard to ensure users are not presented with invalid steps (ie, if their application is under review)
export function CertificateApplicationStepGuard({
  children,
}: PropsWithChildren) {
  // Hooks
  const { pathname } = useLocation()
  const { application } = useCertificateApplication()
  const { applicationId } =
    useParams<
      Params<'/applications/certificate/:applicationId/motor-carrier/submitted'>
    >()

  const submittedPath = buildPath(
    '/applications/certificate/:applicationId/motor-carrier/submitted',
    { applicationId: applicationId! }
  )

  // Redirect to the submitted page once the application is under review
  if (
    application.status === ApplicationStatus.UNDER_REVIEW &&
    pathname !== submittedPath
  )
    return <Navigate to={submittedPath} replace />

  return children || <Outlet />
}
